export default {
  employees: `profile/employees`,
  employeeSetup: `profile/employees/employeeSetup`,
  update: `profile/employees/update`,
  remove: `profile/employees/remove`,
};
